import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { cardTypes } from './cardtypes';

@Component({
  selector: 'takeoff-group-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {
  @Input() cardType;
  @Input() basicCardLink;
  @Input() basicCardextLink;
  @Input('card-data') cardData;
  @Output() onTileClick = new EventEmitter<any>();
  cardsTypeEnum = cardTypes;
  colors = [
    "#1FFF17",
    "#FF5151",
    "#7CB5EC",
    "#E5D355",
    "#8085E9",
    "#F7A35D",
    "#3417FF",
    "#FF1717",
    "#FF8F8F",
    "#FF8FF4"
  ];
  randColor: string;
  constructor() { }

  ngOnInit() {
    this.randColor = this.colors[Math.floor(Math.random() * this.colors.length)];
  }

  onTileChange(data, typeValue) {
    this.onTileClick.emit({ selectedData: data, type: typeValue });
  }
}
